import interceptors from "./interceptors";

const fetchBanners = () => {
  return interceptors({
    url: "/documents/details/Banner",
    method: "GET",
  });
};

export { fetchBanners };
